import { requestApi } from './Api';

export const getPractitioner = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practitioner/get',
    params
  });

export const getPractitioners = (params, navigate) =>
  requestApi({
    navigate,
    url: '/api/practice/member/get_practitioners',
    params,
    onError: () => {}
  });

export const getPractitionerPatients = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/practitioner/get_patients',
    params
  });

export const getPractitionersAdmin = (navigate, params) =>
  requestApi({ navigate, url: '/api/practitioner/get_multiple', params });

export const upsertPractitionerLicense = (navigate, params) =>
  requestApi({
    url: '/api/practitioner/license/upsert',
    navigate,
    params
  });

export const getPractitionerLicenses = (navigate, params) =>
  requestApi({
    url: '/api/practitioner/license/load',
    navigate,
    params
  });

export const getFormsSelection = (navigate, params) =>
  requestApi({ navigate, url: '/api/practice/medical_history/get_default_selection', params });

export const saveFormsSelection = (navigate, params) =>
  requestApi({ navigate, url: '/api/practice/medical_history/save_default_selection', params });

export const getClearingHouseInfo = async (navigate, params) =>
  requestApi({ navigate, url: '/api/admin/claimmd/get', params });
